export interface CloudRequestOptions {
  cloudOrigin: string;
  useDevProxy: boolean;
}

export function normalizeCloudOrigin(value: string): string {
  return value.trim().replace(/\/+$/, "");
}

export function resolveCloudRequestUrl(
  input: string,
  options: CloudRequestOptions,
): string {
  // Absolute URLs are already resolved and must never be concatenated with
  // the configured origin. This also keeps test and custom fetch requests
  // intact.
  if (/^[a-z][a-z\d+.-]*:/i.test(input) || input.startsWith("//")) return input;
  if (options.useDevProxy || !options.cloudOrigin) return input;
  return new URL(input, `${options.cloudOrigin}/`).toString();
}

export function formatCloudNetworkError(
  input: string,
  cause: unknown,
  options: Pick<CloudRequestOptions, "useDevProxy">,
): string {
  const detail = cause instanceof Error && cause.message && cause.message !== "Failed to fetch"
    ? `: ${cause.message}`
    : "";
  if (options.useDevProxy && !/^[a-z][a-z\d+.-]*:/i.test(input)) {
    return `Orni Cloud could not be reached through the local development proxy${detail}. Start the Cloud service or check VITE_ORNI_CLOUD_ORIGIN.`;
  }
  try {
    const target = new URL(input).origin;
    return `Orni Cloud could not be reached at ${target}. Check the network and browser CORS configuration${detail}.`;
  } catch {
    return `Orni Cloud could not be reached. Check the network and browser CORS configuration${detail}.`;
  }
}
